<script setup lang="ts">
import NavigationSplash from '@/components/NavigationSplash.vue'
import PrimeVueToastHost from '@/layouts/partials/PrimeVueToastHost.vue'

// Root component. Renders the active route + global service hosts.
//
// Global hosts:
//   - <ConfirmDialog />     — backs `useConfirm()` from PrimeVue.
//                             Modal overlay covers the whole window.
//   - <DynamicDialog />     — backs `useDialog()`  from PrimeVue.
//   - <PrimeVueToastHost /> — PrimeVue `<Toast>` with our `#container`
//                             slot. PrimeVue v4 hardcodes Portal's
//                             `appendTo: 'body'` internally, so the
//                             overlay TELEPORTS to body. We constrain
//                             it visually by anchoring `.p-toast-*`
//                             positions to `<main>`'s bounding rect
//                             via `--app-main-*` CSS custom properties
//                             (published by `useMainBoundsTracker` in
//                             `default.vue`). The CSS lives in
//                             `main.scss` § "PrimeVue Toast — main-
//                             bound anchor".
//   - <NavigationSplash />  — full-viewport overlay between route
//                             transitions; reads `uiStore.navigating`
//                             which `router/index.ts`'s beforeEach
//                             + afterEach flip. Renders ABOVE every
//                             other host (z-index 9999) so the
//                             user sees a calm transition rather
//                             than a partially-rendered next view.
//
// `<ConfirmDialog :draggable="false">` — disable click-and-drag on
// the dialog; canonical UX is "modal stays where it landed". Set
// per-instance because PrimeVue v4 has no global prop-defaults API.
//
// Native driver toast host (`<Notification />`) lives INSIDE
// default.vue's <main> + plain.vue's wrapper — it doesn't teleport,
// so it's naturally bounded to the layout it's mounted in.
</script>

<template>
  <RouterView />
  <ConfirmDialog :draggable="false" />
  <DynamicDialog />
  <PrimeVueToastHost />
  <NavigationSplash />
</template>
